import CityPageTemplate from "../city-template/CityPageTemplate";
import { manisteeConfig } from "./data";

export default function ManisteePage() {
  return <CityPageTemplate config={manisteeConfig} />;
}